// extracted by mini-css-extract-plugin
export var cardLayout = "_26-1";
export var paginationContainer = "_26-0";